export default __webpack_public_path__ + "314270cba222aa2b1d0f6647fa903dc6.png";